export enum LockedFlightPermissions {
  VIEW = 'VIEW_LOCKED_ROOMS',
}
